/**
 * Clássicos Timeline
 * Ouve o evento nativo `slideshow:select` do slideshow-component
 * (que já calcula o slide ativo corretamente para desktop e mobile)
 * e reflete o índice nos dots dentro dos slides.
 */

class ClassicosTimeline extends HTMLElement {
  constructor() {
    super();
    /** @type {Element[]} */
    this._items = [];
    this._boundOnSelect = this._onSelect.bind(this);
    /** @type {Element | null} */
    this._slideshowComponent = null;
  }

  connectedCallback() {
    if (document.readyState === 'complete') {
      this._connect();
    } else {
      window.addEventListener('load', () => this._connect(), { once: true });
    }
  }

  disconnectedCallback() {
    this._slideshowComponent?.removeEventListener(
      'slideshow:select',
      this._boundOnSelect
    );
  }

  _connect() {
    const section =
      this.closest('.shopify-section') ||
      this.closest('[data-section-id]') ||
      this.parentElement;

    if (!section) return;

    const slideshowComponent = section.querySelector('slideshow-component');
    if (!slideshowComponent) return;

    this._slideshowComponent = slideshowComponent;
    this._items = Array.from(
      section.querySelectorAll('.carousel-default__item--classicos')
    );

    if (this._items.length === 0) return;

    // O slideshow já calcula corretamente qual slide está ativo
    // (usa centro do scroller no mobile, borda esquerda no desktop)
    slideshowComponent.addEventListener('slideshow:select', this._boundOnSelect);

    // Estado inicial
    this._setActive(0);
  }

  /** @param {Event} event */
  _onSelect(event) {
    const index = /** @type {any} */ (event).detail?.index ?? 0;
    this._setActive(index);
  }

  /** @param {number} index */
  _setActive(index) {
    this._items.forEach((item, i) => {
      item.classList.toggle('classicos-active', i === index);
    });
  }
}

if (!customElements.get('classicos-timeline')) {
  customElements.define('classicos-timeline', ClassicosTimeline);
}
